module.exports = __webpack_public_path__ + "static/media/USFlagicoi.6b02918a.png";